import { CALLBACKS } from '../../api/config';
export function onFetchingError(message) {
  var notify = CALLBACKS.notify;
  message ? notify.error(message) : notify.error("We've encountered an unexpected problem while retrieving the screening data. Please try again.");
}
//# sourceMappingURL=notifications.js.map